Monitoring.Views ||= {}

class Monitoring.Views.TaggingRulesEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/tagging_rules/tagging_rules_edit"]

  events:
    'change #tagging-rule-name': 'onChangeName'
    'change #tagging-rule-topics': 'onChangeTopics'
    'change #tagging-rule-tag': 'onChangeTag'
    'change #tagging-rule-sentiment': 'onChangeSentiment'
    'click #edit-keywords': 'onClickEditKeywords'
    'click #cancel': 'onClickCancel'
    'click #save': 'onClickSave'

  initialize: (@options = {}) ->
    @taggingRule     = @options.taggingRule
    @availableTopics = @options.availableTopics
    @availableTags   = @options.availableTags
    @availableSentiments = @options.availableSentiments

  render: =>
    @$el.html(@template(@))
    @renderKeywordsEditView()
    @initializeModal()
    @initializeChosen()
    @updateSaveButtonStatus()
    @

  initializeModal: ->
    $.fn.modal.Constructor.prototype.enforceFocus = ->
    @$el.find('#tagging-rule-edit').modal()

  initializeChosen: ->
    @$el.find('.chosen-select').chosen({width: '395px', enable_split_word_search:true, search_contains:true});

  renderKeywordsEditView: ->
    @keywordsEditView = new Monitoring.Views.SocialContents.Filters.KeywordsFilterView(searchQuery: @taggingRule, forRule: true)
    @$el.append(@keywordsEditView.render().el)
    @$el.find('.filter.collapsed').remove()
    @listenTo(@keywordsEditView, 'changed:keywords', @onChangeKeywords)

  onChangeKeywords: (primary, secondary, excluded, plogic, slogic, elogic) =>
    @taggingRule.set('primary_keywords', primary)
    @taggingRule.set('secondary_keywords', secondary)
    @taggingRule.set('excluded_keywords', excluded)
    @taggingRule.set('primary_keywords_logic', plogic)
    @taggingRule.set('secondary_keywords_logic', slogic)
    @taggingRule.set('excluded_keywords_logic', elogic)

  updateSaveButtonStatus: =>
    if @allMandatoryFieldsAreFilled()
      @$el.find('#save').prop('disabled', false)
    else
      @$el.find('#save').prop('disabled', true)

  allMandatoryFieldsAreFilled: =>
    @nameIsFilled()

  nameIsFilled: ->
    @$el.find('#tagging-rule-name').val().trim().length > 0

  onChangeName: (evt) ->
    @onChangeTextProperty('name')
    @updateSaveButtonStatus()

  onChangeTopics: (evt) ->
    @onChangeMultiselectProperty('topics')

  onChangeTag: (evt) ->
    @onChangeSelectProperty('tag')

  onChangeSentiment: (evt) ->
    @onChangeSelectProperty('sentiment')

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#tagging-rule-#{propertyName.replace('_', '-')}").val().trim()
    @taggingRule.set(propertyName, enteredProperty)

  onChangeSelectProperty: (propertyName) ->
    selectedOptions = @$el.find("#tagging-rule-#{propertyName.replace('_', '-')} option:selected")
    enteredProperty = _.map(selectedOptions, (opt) -> opt.value)[0]
    @taggingRule.set(propertyName, enteredProperty)

  onChangeMultiselectProperty: (propertyName) ->
    selectedOptions = @$el.find("#tagging-rule-#{propertyName.replace('_', '-')} option:selected")
    enteredProperties = _.map(selectedOptions, (opt) -> {id: opt.value, name: $(opt).data('name')})
    @taggingRule.set(propertyName, enteredProperties)

  onClickEditKeywords: ->
    @$el.find('#edit_keywords_modal').modal()

  onClickCancel: ->
    @trigger('cancel')

  onClickSave: ->
    errorOrValid = @taggingRule.validateFields()
    if errorOrValid == "VALID"
      @$el.find('.saving').removeClass('invalid-fields').html('Saving...').show()
      @taggingRule.save({}, {
        success: (response) =>
          @$el.find('#tagging-rule-edit').modal('hide')
          @trigger('afterSave', @taggingRule)
        error: (response) =>
          @$el.find('.saving').html('Error')
          console.log("Error saving alert: #{response}")
      })
    else
      @$el.find('.saving').addClass('invalid-fields').html(errorOrValid).show()
